import styled, { css } from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery, font, color } = baseVariables;

export const StyledRfpCard = styled.div`
  height: 31%;
  border-radius: ${toRem(12)};
  position: relative;

  @media ${mediaQuery.md} {
    width: 32%;
    height: 100%;
  }

  .card-container {
    height: 100%;

    div:first-child {
      height: 100%;

      .card-image {
        width: 100%;
        height: 100%;
        border-radius: ${toRem(12)};
        object-fit: cover;
      }
    }

    .card-title {
      width: 70%;
      background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2));
      color: ${color.base20};
      font-size: ${font.fontM};
      line-height: ${toRem(20)};
      font-weight: ${font.fontWeightRegular};
      box-shadow: ${toRem(0)} ${toRem(-5)} ${toRem(30)} ${toRem(-5)} rgba(0, 0, 0, 1);
      position: absolute;
      left: 5%;
      bottom: 10%;
      overflow: hidden;
      ${css`
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      `}
    }

    .undo-layer {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.75);
      border-radius: ${12};
      button {
        background: transparent;
        font-size: ${toRem(16)};
        font-weight: ${font.fontWeightMedium};
        &:focus-visible {
          outline: -webkit-focus-ring-color auto ${toRem(1)};
        }
      }
    }
  }

  .remove-card {
    width: ${toRem(32)};
    height: ${toRem(32)};
    padding: ${toRem(4)};
    background-color: ${color.neutral20};
    color: ${color.base10};
    border-radius: ${toRem(4)};
    font-size: ${toRem(24)};
    position: absolute;
    top: ${toRem(8)};
    right: ${toRem(8)};
    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }

  .card-shell {
    height: 100%;
    background-color: ${color.neutral20};
    border-radius: ${toRem(12)};

    .shell-title {
      margin-bottom: ${toRem(8)};
      color: ${color.base10};
      font-size: ${toRem(16)};
      line-height: ${toRem(20)};
      font-weight: ${font.fontWeightRegular};
    }

    .shell-subtitle {
      font-size: ${font.fontXs};
      line-height: ${toRem(14)};
      font-weight: ${font.fontWeightRegular};
      color: ${color.base10};
    }
  }
`;
